<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SuppAddMain from '@/views/MessageManagement/SuppManage/TabChild/SuppAddMain';
export default {
  name: 'SuppAdd',
  components: {
    childTab1: SuppAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
